import { UserPlus } from 'lucide-react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Avatar } from '@/components/ui/avatar'
import { Card } from '@/components/ui/card'
import { TabsList, TabsTrigger } from '@/components/ui/tabs'
import { MOBILE_TABS_LIST, MOBILE_TABS_TRIGGER } from '../components/mobileTabs'
import { useDepartmentPositions, useHrDepartments } from '../api/referenceApi'
import type { PersonelFormMode, PersonelFormValues } from '../schemas/personelFormSchema'
import { errorCountByTab, FORM_TABS, type FormTab } from './formTabs'

export function FormHeaderCard({ mode }: { mode: PersonelFormMode; tab: FormTab }) {
  const { t } = useTranslation()
  const { control, formState } = useFormContext<PersonelFormValues>()
  const [ad, pozisyon, depId] = useWatch({ control, name: ['ad', 'pozisyon', 'departman_id'] })
  const departman = useHrDepartments().data.find((d) => d.id === depId)?.name
  const pozisyonAd = useDepartmentPositions(depId).data.find((p) => p.id === pozisyon)?.name
  const errors = errorCountByTab(formState.errors)
/*   const step = FORM_TABS.findIndex((x) => x.value === tab) + 1 */
  const subtitle = [pozisyonAd, departman].filter(Boolean).join(' · ')

  return (
    <Card className="overflow-hidden rounded-2xl border-border/70 shadow-sm">
      <div className="flex flex-wrap items-center gap-4 p-4 sm:flex-nowrap sm:p-5 lg:p-6">
        {ad?.trim() ? (
          <Avatar name={ad} className="size-10 rounded-xl sm:size-16 sm:rounded-2xl [&>span]:bg-primary/10 [&>span]:text-sm [&>span]:text-primary sm:[&>span]:text-lg" />
        ) : (
          <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary sm:size-12 sm:rounded-2xl">
            <UserPlus className="size-3 sm:size-4" />
          </span>
        )}
        <div className="min-w-0 flex-1">
          <h2 className="truncate text-lg font-semibold tracking-tight sm:text-xl">
            {ad?.trim() || t(mode === 'edit' ? 'hr.personel.form.editTitle' : 'hr.personel.form.newPersonel')}
          </h2>
          <p className="truncate text-sm text-muted-foreground">{subtitle || t('hr.personel.form.headerHint')}</p>
        </div>
     {/*    <div className="w-full shrink-0 sm:w-auto sm:text-right">
          <div className="text-xs font-medium text-muted-foreground">{t('hr.personel.form.step', { n: step, total: FORM_TABS.length })}</div>
          <div className="mt-1.5 flex gap-1 sm:justify-end" aria-hidden>
            {FORM_TABS.map((x, i) => (
              <span key={x.value} className={`h-1.5 w-6 rounded-full ${i < step ? 'bg-primary' : 'bg-muted'}`} />
            ))}
          </div>
        </div> */}
      </div>
      <div className="border-t border-border/70 bg-muted/20 px-3 py-2.5 sm:px-5">
        <TabsList aria-label={t('hr.personel.form.addTitle')} className={MOBILE_TABS_LIST}>
          {FORM_TABS.map(({ value, icon: Icon }) => (
            <TabsTrigger key={value} value={value} className={MOBILE_TABS_TRIGGER}>
              <Icon />
              {t(`hr.personel.form.tabs.${value}`)}
              {errors[value] ? (
                <span
                  className="ml-0.5 inline-flex min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-semibold text-destructive-foreground"
                  aria-label={t('hr.personel.form.tabErrors', { n: errors[value] })}
                >
                  {errors[value]}
                </span>
              ) : null}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Card>
  )
}
